<template>
  <div class='detail'>
    <back />
    <div class="content">
      <el-descriptions title="订单信息" :column="3">
        <el-descriptions-item label="申请单号">{{ data.applyNum }} </el-descriptions-item>
        <el-descriptions-item label="门店名称">{{ data.bizName }} </el-descriptions-item>
        <el-descriptions-item label="账户类型">
          <span v-if="data.accountType == 1">支付宝</span>
          <span v-if="data.accountType == 2">银行卡</span>
        </el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ data.accountName }}</el-descriptions-item>
        <el-descriptions-item label="账号">{{ data.accountNum }}</el-descriptions-item>
        <el-descriptions-item label="提现金额（元）">{{ data.applyAmount }}</el-descriptions-item>
        <el-descriptions-item label="可提现金额（元）">{{ data.availableAmount }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ data.createdTime }}</el-descriptions-item>
        <el-descriptions-item label="审核时间" v-if="data.status != 0">{{ data.updatedTime }}</el-descriptions-item>
        <el-descriptions-item label="转账时间" v-if="data.status != 0">{{ data.createdTime }}</el-descriptions-item>
        <el-descriptions-item label="状态"><span :style="data.status == 0 ? 'color:red' : ''">
            <span v-if="data.status == 0">待审核</span>
            <span v-if="data.status == 1">已转账</span>
            <span v-if="data.status == 2">审核失败</span>
            <span v-if="data.status == 3">转账失败</span>
          </span></el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="leave_msg" v-if="data.status == 2">
      <el-descriptions title="" :column="1">
        <el-descriptions-item label="不通过原因">
          {{ data.auditMsg }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

  </div>
</template>

<script>
export default {

  data() {
    return {
      data: {

      },
    }
  },
  created() {
    this.selectExtractApplyListDetail()
  },
  methods: {

    selectExtractApplyListDetail() {
      this.$axios.get(`${this.$api.selectExtractApplyListDetail}/${this.$route.query.id}`,).then((res) => {
        if (res.code == 100) {
          this.data = res.result
        }
      }).catch(err => {
        this.$message({
          message: err.desc,
          type: 'error'
        })

      })
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions:not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 30px !important;
  padding-right: 20px;
}

::v-deep .el-descriptions-item {
  color: #444444;
  font-size: 16px;
  padding-right: 30px;
}

.detail {
  .content {
    margin-top: 30px;
  }

  .content,
  .leave_msg {
    ::v-deep .el-descriptions__title {
      color: #444444;
      font-size: 18px;
    }
  }

  .leave_msg {
    ::v-deep .el-descriptions-item__label {
      margin: 0;
    }

    ::v-deep .el-descriptions-item__container {
      align-items: center !important;
      color: red;
    }
  }
}
</style>
